import CustomerAccessModule from "./CustomerAccessModule";

export default CustomerAccessModule;
